<template>
  <div class="tpl">
    <van-nav-bar title="亿家一家" left-text="返回" right-text="关注" left-arrow fixed @click-left="onClickLeft" @click-right="onClickRight" />
    <div style="height:46px"></div>
    <div class="kefu">
        <img src="../../assets/kefu.png"  @click="kefuShow=true" />
      <!-- <i class="iconfont iconkefu11 icon"></i> -->
    </div>
    <van-popup
      v-model="kefuShow"
      closeable
      position="bottom"
      :style="{ height: '30%' }"
      style="padding-top:40px"
    >
      <div
        class="merchant"
        style="background-color:#fff;margin:10px 0 10px 0; padding:10px; display:flex"
      >
        <div
          style="line-height:30px; border-right: 1px solid #b2b2b2; padding-right:30px; font-size:16px"
        >
          <div>
            <van-icon name="shop-collect" color="red" style="padding-right:10px" />商户信息：
          </div>
          <div>名称：{{item.merchant.merchant_name}}</div>
          <!-- <div>{{item.merchant.address}}</div> -->
          <div>
            <van-icon name="location-o" style="padding-right:10px" />
            {{item.merchant.address}}
          </div>
        </div>
        <div style="flex-grow:1; text-align:center">
          <van-image :src="GLOBAL.IMG + item.qrcode" style="width:100px; height:100px;" />
        </div>
      </div>
    </van-popup>
    <Haibao :id="id" :module="1"></Haibao>
    <div class="main-pic">
        <van-tag class="huodongTag" v-if="item.goods_level==1" mark type="danger">活动</van-tag>
        <vue-swpier :items="slide" autoplay="5000"></vue-swpier>
    </div>
    <!-- <img class="thumbnail" :src="GLOBAL.IMG + item.thumbnail" /> -->
    <div style="background-color:#fff;display: flex;  justify-content: space-between;">
      <div class="price">
        ¥
        <em>{{item.price}}</em>
        <br />
        <span
          style="color:#88888888;"
          v-if="user.user.is_share==1 && user.user.customer_type==2"
        >群主最高返佣：{{item.share_money}}</span>
        <span
          style="color:#88888888; padding-left:10px"
          v-if="user.user.is_share==1 && user.user.customer_type==0"
        >分享师返佣：{{item.share_sub_money}}</span>
      </div>
      <div style="padding:28px 20px 0 0;color:#888888">{{item.post_hits}} 次</div>
    </div>
    <div class="title" ref="merchant">{{item.post_title}}</div>
    <yijiaEWM></yijiaEWM>
    <div class="detail" v-html="item.post_content"></div>
    <Comment :id="id" module="1"></Comment>
    <Recommend :list="item.recommend_goods" module="shop"></Recommend>

    <div style="height:50px"></div>
    <div class="bottom">
      <van-sku
        ref="sku"
        v-model="skuShow"
        :sku="item.sku"
        :goods="item.goods"
        :goods-id="item.id"
        :quota="quota"
        :quota-used="quotaUsed"
        :message-config="messageConfig"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked"
      />
      <van-goods-action>
        <van-goods-action-icon icon="home-o" text="首页" @click="goHome" />
        <van-goods-action-icon icon="cart-o" text="购物车" @click="goCart" :badge="cartNum" />
        <van-goods-action-icon icon="shop-o" text="店铺" @click="goMerchant" />
        <van-goods-action-icon
          v-if="item.is_collect"
          icon="star"
          text="取消收藏"
          v-on:click="shouCangCancle()"
          color="#ff5000"
        />
        <van-goods-action-icon
          v-if="!item.is_collect"
          icon="star"
          text="收藏"
          color="#1baeae"
          v-on:click="shouCang()"
        />
        <van-goods-action-button color="-webkit-linear-gradient(left,#0dc3c3,#098888)" type="warning" text="加入购物车" @click="addCart" />
        <van-goods-action-button color="linear-gradient(90deg,#0dc3c3,#098888)" type="danger" text="立即购买" @click="buy" />
      </van-goods-action>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Recommend from "@/components/tuijian.vue";
import { GoodsAction, GoodsActionIcon, GoodsActionButton, Sku ,Popup} from "vant";
import { Icon } from "vant";
import vueSwpier from "@/components/vueSwiper_shopImg.vue";
import Comment from "@/components/comment.vue";
import Haibao from "@/components/haibao.vue";
import yijiaEWM from "@/components/yijia.vue";
import wx_share from '../../common/wx_share.js';
Vue.use(Icon);
Vue.use(GoodsAction).use(GoodsActionButton).use(GoodsActionIcon).use(Sku).use(Popup);
export default {
  name: "goodsDetail",
  components: {
    Recommend,
    vueSwpier,
    Comment,
    Haibao,
    yijiaEWM,
  },
  data() {
    return {
      kefuShow: false,
      slide: [],
      cartNum: 0,
      id: this.$route.params.id,
      user: { token: "", user: {id:0, is_share: 0, customer_type: 0 } },
      item: {
        sku: { tree: [], none_sku: true },
        goods: {},
        is_collect: 0,
        merchant: { merchant_name: "", id: 0 },
      },
      skuShow: false,

      messageConfig: {
        // 数据结构见下方文档
      },
      goodsId: "0",
      quota: 0,
      quotaUsed: 0,
      buyDetail: {
        goods_id: this.$route.params.id,
        num: 1,
        attr_json: { n1: "", n2: "", n3: "" },
      },
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight(){
        this.$router.push("/article/detail/71");
    },
    goHome() {
      this.$router.push("/");
    },
    goMerchant() {
      // this.$toast('店铺功能开发中');
      this.$router.push("/shop/merchant/" + this.item.merchant.id);
    },
    getCartNum() {
      this.$http
        .get(this.GLOBAL.API + "s_shop/cart/cartList", {
          params: {},
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" },
        })
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            for (let k in data.data) {
              for (let i in data.data[k]["goods"]) {
                this.cartNum = this.cartNum + data.data[k]["goods"][i].num;
              }
            }
          } else {
            this.$toast(data.msg);
          }
        });
    },
    shouCang() {
      this.$http
        .post(
          this.GLOBAL.API + "/s_user/collection/add",
          { id: this.id, module: 1 },
          {
            params: {},
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          this.$toast(data.msg);
          if (data.code == 1) {
            this.item.is_collect = 1;
          }
        });
    },
    shouCangCancle() {
      this.$http
        .post(
          this.GLOBAL.API + "/s_user/collection/delete",
          { id: this.id, module: 1 },
          {
            params: {},
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          this.$toast(data.msg);
          if (data.code == 1) {
            this.item.is_collect = 0;
          }
        });
    },
    onBuyClicked() {
      let sku = this.$refs.sku.getSkuData();
      console.log(sku);
      this.buyDetail.num = sku.selectedNum;
      if (sku.selectedSkuComb.s1) {
        this.buyDetail.attr_json.n1 = sku.selectedSkuComb.s1;
      }
      if (sku.selectedSkuComb.s2) {
        this.buyDetail.attr_json.n2 = sku.selectedSkuComb.s2;
      }
      if (sku.selectedSkuComb.s3) {
        this.buyDetail.attr_json.n3 = sku.selectedSkuComb.s3;
      }
      localStorage.setItem("buyDetail", JSON.stringify(this.buyDetail));
      this.$router.push("/shop/createorder/" + this.id + "/buy");
    },
    onAddCartClicked() {
      let sku = this.$refs.sku.getSkuData();
      console.log(sku);
      this.buyDetail.num = sku.selectedNum;
      if (sku.selectedSkuComb.s1) {
        this.buyDetail.attr_json.n1 = sku.selectedSkuComb.s1;
      }
      if (sku.selectedSkuComb.s2) {
        this.buyDetail.attr_json.n2 = sku.selectedSkuComb.s2;
      }
      if (sku.selectedSkuComb.s3) {
        this.buyDetail.attr_json.n3 = sku.selectedSkuComb.s3;
      }
      this.$http
        .post(
          this.GLOBAL.API + "s_shop/cart/addCart",
          {
            post_id: this.id,
            attr_json: JSON.stringify(this.buyDetail.attr_json),
          },
          {
            params: {},
            headers: {
              "XX-Token": this.user.token,
              "XX-Device-Type": "mobile",
            },
          }
        )
        .then((response) => {
          let data = response.body;
          this.$toast(data.msg);
        });
    },
    goCart() {
      this.$router.push("/shop/cart");
    },
    addCart() {
      this.skuShow = true;
    },
    buy() {
      this.skuShow = true;
    },
    getDetail() {
      this.slide = [];
      this.$http
        .get(this.GLOBAL.API + "s_shop/goods/goodsDetail", {
          params: { id: this.id },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" },
        })
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            for (let i in data.data.thumbsnails) {
              this.slide.push({
                id: i,
                image: data.data.thumbsnails[i],
                url: "#",
              });
            }
            data.data.post_content = data.data.post_content.replace(
              /src="default/g,
              'width= 100% src="' + this.GLOBAL.IMG + "default"
            );
            data.data.post_content = data.data.post_content.replace(
              /src="groupshop/g,
              'width= 100% src="' + this.GLOBAL.IMG + "groupshop"
            );
            this.item = data.data;
            let info ={"post_title":this.item.post_title,"desc":this.item.post_title,"thumbnail":'http://yijia.sihandbms.cn/upload/'+this.item.thumbnail}
            wx_share.wx_share(this.GLOBAL.API,this.user,info);
            // this.item.sku = JSON.parse(this.item.sku);
          }
        });
    },
    
  },
  watch: {
    $route(to, from) {
      if (from.params.id) {
        //   this.$router.go(0);
        this.id = to.params.id;
        this.getDetail();
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      }
    },
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.getCartNum();
    }
    this.getDetail();
    if (this.$route.query.share) {
      localStorage.setItem("share", this.$route.query.share);
    }
    document.documentElement.scrollTop = 0;
  },
};
</script>
<style lang="scss" scoped>
.tpl {
  text-align: left;
  background-color: #f6f6f6;
}
.main-pic{
    position: relative;
    .huodongTag{
        position: absolute;
        z-index: 999;
        top:0;
        left:0;
    }
}
.thumbnail {
  width: 100%;
  display: block;
}
.price {
  color: #f2270c;
  em {
    font-size: 30px;
    font-family: JDZH-Regular;
  }
  padding: 10px;
  background-color: #ffffff;
}
.title {
  font-size: 16px;
  color: #222333;
  font-weight: 700;
  padding: 10px;
  border-radius: 0 0 10px 10px;
  margin-bottom: 10px;
  background-color: #ffffff;
}
.detail {
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 10px;
}
.kefu {
  position: fixed;
  bottom: 150px;
  z-index: 999;
  width: 60px;
  height: 60px;
  img{
      width:60px;
      height:60px;
  }
  right: 10px;
  text-align: right;
  background-color: #fff;
  border-radius: 30px;
  .icon {
    display: block;
    color: aqua;
    font-size: 40px;
    margin: -5px 4px 0 0px;
  }
}
</style>